import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

/** Answer something Connie passed on — it lands in the partner's Messages, with the usual heads-up. */
export function ReplyToPartner({ feedbackId, activityId, testId, onSent, children }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    const body = text.trim();
    if (!body) return false;
    setBusy(true);
    try {
      await api.post("/hub/connie/reply", { body, feedback_id: feedbackId, activity_id: activityId });
      toast.success("Sent — it's in their Messages");
      setText("");
      onSent?.();
      return true;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "That didn't send");
      return false;
    } finally { setBusy(false); }
  };
  return (
    <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap", alignItems: "center" }}>
      <input className="inp" value={text} onChange={(e) => setText(e.target.value)} placeholder="Write your reply — it goes to their Messages"
             onKeyDown={(e) => { if (e.key === "Enter") send(); }}
             style={{ flex: "1 1 280px" }} data-testid={`${testId}-input`} />
      <button className="btn btn-primary btn-sm" disabled={busy || !text.trim()} onClick={send} data-testid={`${testId}-send`}>
        {busy ? "Sending…" : "Send reply"}
      </button>
      {children}
    </div>
  );
}

export default ReplyToPartner;
